import { HotelProduct } from '@/api/Cart/cart.interfaces';
import { Market } from '@shared/config/market/market.models';
import { convertToDate, getDurationInDays } from '@shared/helpers/datetime/datetime';

export function getReadMoreLink(market: Market): string | undefined {
    return market.links?.sembonus ?? undefined;
}

export function getStampsToEarn(hotels: HotelProduct[]): number {
    return hotels.reduce((total, hotel) => {
        const fromDate = convertToDate(hotel.FromDate);
        const toDate = convertToDate(hotel.ToDate);

        const numberOfRooms = hotel.Rooms ? hotel.Rooms.length : 0;
        const numberOfNights = getDurationInDays(fromDate, toDate);
        return total + numberOfRooms * numberOfNights;
    }, 0);
}
